// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PMH44","content":"styles_content__37y_N"};